import { combineReducers } from 'redux';
import authReducer from '../containers/AuthWrapper/reducer';
// User Reducer
import homeReducer from '../containers/Layouts/User/Home/reducer';
import profileReducer from '../containers/Layouts/User/Profile/reducer';
import caseDetailsReducer from '../containers/Layouts/User/CaseDetails/reducer';
// Admin Reducer
import dentistsReducer from '../containers/Layouts/Admin/Dentists/reducer';
import adminCasesReducer from '../containers/Layouts/Admin/AllCases/reducer';
import adminPatientsReducer from '../containers/Layouts/Admin/Patients/reducer';
import adminDashboardReducer from '../containers/Layouts/Admin/dashboard/reducer';
import adminCaseDetailsReducer from '../containers/Layouts/Admin/AdminCaseDetails/reducer';
import adminAvailableUnitsReducer from '../containers/Layouts/Admin/AvailableUnits/reducer';
import dailyReportReducer from '../containers/Layouts/Admin/DailyReport/reducer';
import adminPatientDetailsReducer from '../containers/Layouts/Admin/PatientDetails/reducer';
import adminDentistDetailsReducer from '../containers/Layouts/Admin/DentistDetails/reducer';
// Default Reducer
import signInReducer from '../containers/Layouts/Default/Signin/reducer';
import registerReducer from '../containers/Layouts/Default/Register/reducer';
import verifyUserReducer from '../containers/Layouts/Default/VerifyUser/reducer';
import resetPasswordReducer from '../containers/Layouts/Default/ResetPassword/reducer';
import forgetPasswordReducer from '../containers/Layouts/Default/ForgetPassword/reducer';
// Shared Reducer
import sharedReducer from "../shared/redux/reducers/sharedReducer";
import imageUploadReducer from "../shared/redux/reducers/imageUploadReducer";

import chatReducer from '../containers/Chat/reducer';
import historyLogsReducer from "../containers/History/reducer";

export default combineReducers({
    register: registerReducer,
    verifyUser: verifyUserReducer,
    signInUser: signInReducer,
    auth: authReducer,
    forgetPassword: forgetPasswordReducer,
    resetPassword: resetPasswordReducer,
    dentists: dentistsReducer,
    home: homeReducer,
    profile: profileReducer,
    caseDetails: caseDetailsReducer,
    adminPatients: adminPatientsReducer,
    adminDashboard: adminDashboardReducer,
    adminCases: adminCasesReducer,
    adminCaseDetails: adminCaseDetailsReducer,
    adminAvailableUnits: adminAvailableUnitsReducer,
    adminDailyReport: dailyReportReducer,
    adminAllDailyReports: dailyReportReducer,
    adminPatientDetails: adminPatientDetailsReducer,
    adminDentistDetails: adminDentistDetailsReducer,
    chatData: chatReducer,
    historyLogs: historyLogsReducer,
    global: sharedReducer,
    imageUploadReducer
})


// WEBPACK FOOTER //
// ./src/utils/rootReducer.js